import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { isFieldInvalid } from '../home-cuenta-form.validators';
import { AnalyticsTagService } from '../../../../../services/analytics-tag.service';
import {
  HomeCuentaPoliticasModalComponent,
  HomeCuentaPoliticasTipo,
} from '../home-cuenta-politicas-modal/home-cuenta-politicas-modal.component';

@Component({
  selector: 'app-home-cuenta-form-footer',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, HomeCuentaPoliticasModalComponent],
  templateUrl: './home-cuenta-form-footer.component.html',
  styleUrls: ['./home-cuenta-form-footer.component.scss'],
})
export class HomeCuentaFormFooterComponent {
  @Input() idPrefix = 'home-cuenta';
  @Input() showBackLink = false;
  @Input() fieldsComplete = false;
  @Output() back = new EventEmitter<void>();
  @Output() submit = new EventEmitter<void>();

  readonly checksForm = this.fb.nonNullable.group({
    terminos: [false, Validators.requiredTrue],
    datos: [false, Validators.requiredTrue],
  });

  modalOpen = false;
  modalTipo: HomeCuentaPoliticasTipo = 'P';

  constructor(
    private readonly fb: FormBuilder,
    private readonly analyticsTag: AnalyticsTagService
  ) {}

  get canSubmit(): boolean {
    return this.fieldsComplete && this.checksForm.valid;
  }

  isInvalid(key: string): boolean {
    return isFieldInvalid(this.checksForm, key);
  }

  openPoliticas(tipo: HomeCuentaPoliticasTipo, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.modalTipo = tipo;
    this.modalOpen = true;
  }

  onPoliticasClosed(): void {
    this.modalOpen = false;
  }

  onPoliticasAccepted(tipo: HomeCuentaPoliticasTipo): void {
    if (tipo === 'T') {
      this.checksForm.get('terminos')?.setValue(true);
      this.checksForm.get('terminos')?.markAsDirty();
      this.checksForm.get('terminos')?.markAsTouched();
    } else {
      this.checksForm.get('datos')?.setValue(true);
      this.checksForm.get('datos')?.markAsDirty();
      this.checksForm.get('datos')?.markAsTouched();
    }
  }

  onBack(): void {
    this.back.emit();
  }

  onSubmit(): void {
    if (!this.canSubmit) {
      this.checksForm.markAllAsTouched();
      return;
    }

    this.analyticsTag.trackCtaClick({
      ctaLabel: 'Crear cuenta',
      ctaSection: 'form-cuenta',
      ctaComponent: 'home-cuenta-form-footer',
      ctaElementId: 'btn-home-crear-cuenta',
      hu: '8300',
    });

    this.submit.emit();
  }

  resetChecks(): void {
    this.checksForm.reset({
      terminos: false,
      datos: false,
    });
  }

  /** Quita marcas de error/touched sin cambiar los valores. */
  clearValidationState(): void {
    this.checksForm.markAsPristine();
    this.checksForm.markAsUntouched();
    Object.values(this.checksForm.controls).forEach((control) => {
      control.markAsPristine();
      control.markAsUntouched();
    });
  }
}
